import * as api from '../../services/luckyMoney'

export const FETCH_LUCKYMONEYS= 'FETCH_LUCKYMONEYS';
export const FETCH_WINNERDETAILS= 'FETCH_WINNERDETAILS';




export const fetchLuckyMoneys = (params, pagination, sort, extra) => {

    return {
        type: FETCH_LUCKYMONEYS,
        payload: {
            promise: api.findLuckyMoneys(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};

export const fetchWinnerDetails = (params, pagination, sort, extra) => {

    return {
        type: FETCH_WINNERDETAILS,
        payload: {
            promise: api.findWinnerDetails(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/luckyMoney.js